import React from "react";
import "../css/UsersTab.css";

const UsersTab = ({ allUsers }) => {
  return (
    <div>
      <h2>👥 Registered Users</h2>
      {allUsers.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <div className="users-list">
          {allUsers.map((user) => (
            <div key={user.uid} className="user-card">
              <img
                src={user.photoURL}
                alt={user.firstName}
                className="user-avatar"
              />
              <div>
                <p>
                  <strong>{user.firstName}</strong>
                </p>
                <p>{user.email}</p>
                <p className="role">{user.role}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default UsersTab;
